export const initialState = {
  organizations: [],
  organization: {},
  orgTherapistLimit: 0,
  orgOngoingTreatmentLimit: 0,
  loading: false
};
